
import React from 'react';
import { Users, ChevronDown, ChevronRight } from 'lucide-react';
import { TeamItemProps } from './types';

const TeamItem = ({ name, isExpanded, isActive, onClick }: TeamItemProps) => {
  return (
    <li 
      className="flex items-center justify-between py-2 px-3 rounded-md hover:bg-sidebar-accent/50 cursor-pointer"
      onClick={onClick}
    >
      <div className="flex items-center gap-2">
        <Users className="h-4 w-4" />
        <span className="text-sm">{name}</span>
      </div>
      {isExpanded ? 
        <ChevronDown className="h-4 w-4" /> : 
        <ChevronRight className="h-4 w-4" />
      }
    </li>
  );
};

export default TeamItem;
